<div *ngIf="portalProduct" class="sub-list-item bg-white border mt-3 p-3 d-flex flex-column align-items-center justify-content-between h-100">
  <!-- image, title, description -->
  <div class="d-flex flex-column align-items-center gap-3 w-100">
    <img
      alt="{{ portalProduct.DisplayName }}"
      class="sub-product-image"
      src="{{ portalProduct.PrimaryImage | contentImage: '6' }}"
    />
    <p class="font-size-18 fw-bold text-center mb-0">{{ portalProduct.DisplayName }}</p>
    <p class="font-size-14 text-center mb-0 subs-description" [innerHTML]="portalProduct.Description"></p>
  </div>
  <!-- price, button -->
  <div class="d-flex flex-column align-items-center gap-3 w-100 mt-3">
    <p class="fw-bold font-size-14 mb-0">
      {{ portalProduct.MerchantPrice / 100 | FortressCurrencyPipe }}
    </p>
    <button class="btn sub-buy-btn fw-bold w-100 font-size-14" (click)="addSubscriptionProductToCart()">
      Buy Now
    </button>
  </div>
</div>

<!--Product info modal-->
<ng-template #productInfo let-modal>
  <div class="text-black bg-white">
    <div class="modal-header border-bottom-0 pb-0">
      <p class="font-size-14 fw-bold mx-auto">Subscription Details</p>
    </div>
    <hr class="mt-0 mx-5" />
    <div class="modal-body">
      <div class="row">
        <div class="col-2">
          <div
            class="text-center rounded info-image-bg"
            [ngClass]="{ 'bg-primary': portalProduct.ProductType == 1, 'bg-secondary': portalProduct.ProductType == 3 }"
          >
            <img alt="imagedetails" class="info-product-image my-2" src="{{ portalProduct.PrimaryImage | contentImage: '6' }}" />
          </div>
        </div>
        <div class="col-10">
          <p>{{ portalProduct.DisplayName }}</p>
          <p>
            <span class="fw-bold">Cost: </span>
            {{ portalProduct.MerchantPrice / 100 | FortressCurrencyPipe }}
          </p>
          <p [innerHTML]="portalProduct.Description"></p>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-primary close-info-btn fw-bold" (click)="modal.dismiss('close')">Close</button>
      </div>
    </div>
  </div>
</ng-template>
